export const GET_ALL_PAYMENT_DETAILS = "GET_ALL_PAYMENT_DETAILS"